import type { AssessmentConfig, ExperimentMeta, ExperimentPack, KnowledgeItem, MissionDefinition } from "./schemas.js";
import { validateExperimentPack } from "./validators.js";

export interface RawExperimentParts {
  experiment: ExperimentMeta;
  mission: MissionDefinition;
  rules: unknown[];
  knowledge: KnowledgeItem[];
  assessment: AssessmentConfig;
}

/**
 * 拼装 + 校验一个实验包。用 import.meta.glob 按 slug 发现 experiments/ 下具体实验内容是产物工程
 * 的职责，引擎只负责"给定五份 JSON，拼成 ExperimentPack 并校验"（tech/108 §9 物理分离后的边界）。
 */
export function assembleExperimentPack(parts: RawExperimentParts): ExperimentPack {
  const pack: ExperimentPack = { ...parts };
  const result = validateExperimentPack(pack);
  if (!result.valid) {
    throw new Error(`[pack-loader] 实验包 "${parts.experiment.id}" 校验失败：\n${result.errors.join("\n")}`);
  }
  return pack;
}
